module.exports = __webpack_public_path__ + "img/brillante_1.df604ad2.svg";